module.exports = __webpack_public_path__ + "img/advisory5.c8d1d70f.svg";